/* tslint:disable: no-use-before-declare */
import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  Input,
  forwardRef,
  ViewChild,
  OnChanges,
} from '@angular/core';
import { NG_VALUE_ACCESSOR, NgModel } from '@angular/forms';
import { text } from '@angular/core/src/render3';
import { environment } from 'src/environments/environment';

export const CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => FormInputFileComponent),
  multi: true,
};

@Component({
  selector: 'app-form-input-file',
  templateUrl: './form-input-file.component.html',
  styleUrls: ['../../../../invStyles.sass', './form-input-file.component.sass'],
  providers: [CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR],
})
export class FormInputFileComponent implements OnChanges, OnInit {
  maxFileSizeInMB = environment.maxFileSizeInMB;
  supportedFileTypes = environment.supportedFileTypes;

  @Output() reset: EventEmitter<any> = new EventEmitter();
  @Input() fileName: string;
  @Input() label: string;
  @Input() id: string;
  @ViewChild('file') file: NgModel;

  innerFile: any;

  FileSizeIsValid = true;
  IsFileSupported = true;

  constructor() {}

  ngOnInit() {
    setTimeout(() => this.file.control.setErrors({ invalid: true }));
  }
  ngOnChanges() {
    console.log(this.fileName);
  }
  changeFile(event, file: any) {
    console.log('nombreArchivo:', this.fileName);
    const fileNameArray = file.name.split('.');
    const fileType = fileNameArray[fileNameArray.length - 1];
    this.IsFileSupported =
      this.supportedFileTypes.filter(
        x => x.toLowerCase() === fileType.toLowerCase()
      ).length > 0
        ? true
        : false;
    this.FileSizeIsValid =
      file.size <= 1024 * 1024 * this.maxFileSizeInMB ? true : false;
    this.file.control.setErrors(
      this.IsFileSupported && this.FileSizeIsValid ? null : { invalid: true }
    );

    this.innerFile = this.file;
    this.propagateChange(this.innerFile);
  }

  get value(): any {
    return this.innerFile;
  }

  resetFile() {
    this.file.reset(null);
    this.innerFile = null;
    this.fileName = '';
    this.propagateChange(this.innerFile);
    this.reset.emit();
    this.FileSizeIsValid = true;
    this.IsFileSupported = true;
  }

  propagateChange = (_: any) => {};

  writeValue(value: any) {}

  registerOnChange(fn: any) {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any) {}
}
